export default "skymp5-front/ba7f86afe59d769feb36fbaa88a5faca.svg";